import { css } from "@emotion/react";
import { ReactNode } from "react";

interface IconBoxProps {
  children: ReactNode;
}

const IconBox = ({ children }: IconBoxProps) => {
  return (
    <div
      css={css`
        display: flex;
        width: 50px;
        height: 50px;
        background: linear-gradient(
          286.59deg,
          rgba(218, 236, 248, 0.34) 9.17%,
          rgba(218, 236, 248, 0) 109.76%
        );
        border-radius: 50%;
        align-items: center;
        justify-content: center;
      `}
    >
      {children}
    </div>
  );
};

export default IconBox;
